module.exports = __webpack_public_path__ + "img/remove-formatting.aeb3b7bb.svg";